import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {PaisesContainer} from './Screen';

export const PaisesView = () =>{

    return (
        <Page title={'Países'}>{<PaisesContainer/>}</Page>
    )
}